import tippy from "tippy.js";

export function editEntryModalTooltip(entry) {
  const modal = document.createElement("entry-edit-modal");
  modal.setEntry = entry;
  return modal;
}

export function tippyHandler({ content, parent }) {
  const tippyWrap = document.createElement("div");
  tippyWrap.append(parent);

  tippy(tippyWrap, {
    content: content,
    delay: [0, 0],
    duration: [0, 0],
    trigger: "click",
    hideOnClick: true, //import.meta.env.MODE === "development" ? "toggle" : true,
    interactive: true,
    // appendTo: () => tippyWrap,
  });

  return tippyWrap;
}
